// extracted by mini-css-extract-plugin
export default {"container":"CommandPrompt_container__Sp8Xk"};